/* S3 media base + path helpers. */
export const bucket = "https://gqm-dany-web-media.s3.amazonaws.com/";

export const img = (p: string) => `${bucket}imgs/${p}`;
export const vid = (p: string) => `${bucket}videos/${p}`;
export const pdf = (p: string) => `${bucket}pdfs/${p}`;
